import enviro from 'enviro';
import { prepareLocalSendMessageRpc, prepareLocalSendMessagesRpc, prepareLocalToolResponseRpc, cancelTurnRpc } from '../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineService';
import { buildBenderProxyUrl, fetchLocalAgentRoutes, getBenderProxyOrigin } from '../localDev/benderProxy';
export async function hasLocalAgentRoute(agentId) {
  if (!enviro.isQa()) {
    return false;
  }
  const localAgentRoutes = await fetchLocalAgentRoutes();
  return localAgentRoutes.some(route => route.agentId === agentId);
}
export async function postLocalTq2Request(localEnqueuePath, tq2Request) {
  const response = await fetch(buildBenderProxyUrl(localEnqueuePath), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(tq2Request)
  });
  if (!response.ok) {
    throw new Error(`Local agent enqueue failed with status ${response.status}`);
  }
  if (!getBenderProxyOrigin() && !response.headers.get('x-bender-proxy-target')) {
    throw new Error('Local agent enqueue did not route through bender-proxy');
  }
}
export async function prepareAndEnqueueLocalSendMessage(client, request) {
  const response = await client.call(prepareLocalSendMessageRpc, {
    request
  });
  try {
    await postLocalTq2Request(response.localEnqueuePath, response.tq2Request);
  } catch (error) {
    await client.call(cancelTurnRpc, {
      request: {
        conversationId: response.conversationId,
        turnId: response.turnId
      }
    });
    throw error;
  }
  return response;
}
export async function prepareAndEnqueueLocalSendMessages(client, request) {
  const response = await client.call(prepareLocalSendMessagesRpc, {
    request
  });
  try {
    await postLocalTq2Request(response.localEnqueuePath, response.tq2Request);
  } catch (error) {
    await client.call(cancelTurnRpc, {
      request: {
        conversationId: response.conversationId,
        turnId: response.turnId
      }
    });
    throw error;
  }
  return response;
}
export async function prepareAndEnqueueLocalToolResponse(client, request) {
  const response = await client.call(prepareLocalToolResponseRpc, {
    request
  });
  try {
    await postLocalTq2Request(response.localEnqueuePath, response.tq2Request);
  } catch (error) {
    await client.call(cancelTurnRpc, {
      request: {
        conversationId: request.conversationId,
        turnId: request.turnId
      }
    });
    throw error;
  }
  return response;
}